import Phaser from 'phaser';
import type { EnemyId } from './enemies';

// Authored vector effects; no external art assets.
export function spiritEffect(scene:Phaser.Scene,x:number,y:number,birth:boolean,scale=1):void {
  const color=birth?0x9cf6d9:0xc3b5ff;
  const ring=scene.add.ellipse(x,y,90*scale,22*scale).setStrokeStyle(3,color,.9).setDepth(15);
  scene.tweens.add({targets:ring,scaleX:birth?.2:1.7,scaleY:birth?.2:1.7,alpha:0,duration:850,onComplete:()=>ring.destroy()});
  for(let i=0;i<14;i++){
    const angle=i*Math.PI*2/14,dx=Math.cos(angle)*48*scale,dy=Math.sin(angle)*22*scale;
    const mote=scene.add.circle(x+(birth?dx:0),y+(birth?-90*scale+dy:-30*scale),2+(i%3),color,.9).setDepth(16);
    scene.tweens.add({targets:mote,x:x+(birth?0:dx),y:y+(birth?-35*scale:-115*scale+dy),alpha:0,delay:i*18,duration:800,onComplete:()=>mote.destroy()});
  }
}

export function ghostDeath(scene:Phaser.Scene,body:Phaser.GameObjects.Container,kind:EnemyId,destroy=true,floorY=body.y):void {
  if(body.getData('dying'))return;
  body.setData('dying',true);
  for(const child of body.list)if(child instanceof Phaser.GameObjects.Text)child.setVisible(false);
  const x=body.x,scale=Math.abs(body.scaleY);
  // Krasue is a floating head; corporeal ghosts topple onto the floor.
  scene.tweens.add({targets:body,angle:kind==='krasue'?12:88,y:floorY+(kind==='krasue'?-18:0),duration:380,ease:'Cubic.easeIn'});
  scene.time.delayedCall(500,()=>{spiritEffect(scene,x,floorY,false,scale);scene.tweens.add({targets:body,alpha:0,duration:850,onComplete:()=>{if(destroy)body.destroy(true);else body.setVisible(false);}});});
}
